import { Token } from '@uniswap/sdk-core'
import { IMulticallProvider, ITokenProvider, TokenAccessor } from '@uniswap/smart-order-router'
import { ProviderConfig } from '@uniswap/smart-order-router/build/main/providers/provider'
import { SupportedChainId } from 'constants/chains'
import _ from 'lodash'
import { IERC20Metadata__factory } from 'types/v3'

export class TokenProvider implements ITokenProvider {
  constructor(private chainId: SupportedChainId, protected multicall2Provider: IMulticallProvider) {}

  public async getTokens(_addresses: string[], providerConfig?: ProviderConfig): Promise<TokenAccessor> {
    const addressToToken: { [address: string]: Token } = {}
    const symbolToToken: { [symbol: string]: Token } = {}

    const addresses = _(_addresses)
      .map((address) => address.toLowerCase())
      .uniq()
      .value()

    if (addresses.length > 0) {
      const [symbolsResult, decimalsResult] = await Promise.all([
        this.multicall2Provider.callSameFunctionOnMultipleContracts<undefined, [string]>({
          addresses,
          contractInterface: IERC20Metadata__factory.createInterface(),
          functionName: 'symbol',
          providerConfig,
        }),
        this.multicall2Provider.callSameFunctionOnMultipleContracts<undefined, [number]>({
          addresses,
          contractInterface: IERC20Metadata__factory.createInterface(),
          functionName: 'decimals',
          providerConfig,
        }),
      ])

      const { results: symbols } = symbolsResult
      const { results: decimals } = decimalsResult

      for (let i = 0; i < addresses.length; i++) {
        const address = addresses[i]!

        const symbolResult = symbols[i]
        const decimalResult = decimals[i]

        if (!symbolResult?.success || !decimalResult?.success) {
          continue
        }

        const symbol = symbolResult.result[0]!
        const decimal = decimalResult.result[0]!

        addressToToken[address.toLowerCase()] = new Token(this.chainId, address, decimal, symbol)
        symbolToToken[symbol.toLowerCase()] = addressToToken[address.toLowerCase()]!
      }
    }

    return {
      getTokenByAddress: (address: string): Token | undefined => {
        return addressToToken[address.toLowerCase()]
      },
      getTokenBySymbol: (symbol: string): Token | undefined => {
        return symbolToToken[symbol.toLowerCase()]
      },
      getAllTokens: (): Token[] => {
        return Object.values(addressToToken)
      },
    }
  }
}
